module.exports = "/assets/a6309e9513b9571293ffd634fb7a3a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2L.png
// module id = 987
// module chunks = 0